const shopItems = [
  {
    title: "Lucky potions",
    type: "item",
    color: "#3e7f33",
    miniimg: "potion-images/120px/luck1x1.webp",
    sizes: ["S", "M", "L"],
    stars: [1, 2, 3],
    variants: [
      // Small Lucky Potion Variants (Power 1, 2, 3, Size S, M, L)
      {
        power: 1,
        size: "S",
        title: "Small Lucky Potion",
        miniimg: "potion-images/120px/luck1x1.webp",
        cost: 1000,
        ddCost: 1,
        multiplyer: 10,
        timer: 1,
        type: "potion",
      },
      {
        power: 2,
        size: "S",
        title: "Small Lucky Potion II",
        miniimg: "potion-images/120px/luck1x2.webp",
        ddCost: 5,
        multiplyer: 25,
        timer: 1,
        type: "potion",
      },
      {
        power: 3,
        size: "S",
        title: "Small Lucky Potion III",
        miniimg: "potion-images/120px/luck1x3.webp",
        ddCost: 10,
        multiplyer: 50,
        timer: 1,
        type: "potion",
      },

      // Medium Lucky Potion Variants (Power 1, 2, 3, Size S, M, L)
      {
        power: 1,
        size: "M",
        title: "Medium Lucky Potion",
        miniimg: "potion-images/120px/luck2x1.webp",
        cost: 4000,
        ddCost: 4,
        multiplyer: 10,
        timer: 5,
        type: "potion",
      },
      {
        power: 2,
        size: "M",
        title: "Medium Lucky Potion II",
        miniimg: "potion-images/120px/luck2x2.webp",
        ddCost: 17,
        multiplyer: 25,
        timer: 5,
        type: "potion",
      },
      {
        power: 3,
        size: "M",
        title: "Medium Lucky Potion III",
        miniimg: "potion-images/120px/luck2x3.webp",
        ddCost: 40,
        multiplyer: 50,
        timer: 5,
        type: "potion",
      },

      // Large Lucky Potion Variants (Power 1, 2, 3, Size S, M, L)
      {
        power: 1,
        size: "L",
        title: "Large Lucky Potion",
        miniimg: "potion-images/120px/luck3x1.webp",
        cost: 7000,
        ddCost: 7,
        multiplyer: 10,
        timer: 10,
        type: "potion",
      },
      {
        power: 2,
        size: "L",
        title: "Large Lucky Potion II",
        miniimg: "potion-images/120px/luck3x2.webp",
        ddCost: 35,
        multiplyer: 25,
        timer: 10,
        type: "potion",
      },
      {
        power: 3,
        size: "L",
        title: "Large Lucky Potion III",
        miniimg: "potion-images/120px/luck3x3.webp",
        ddCost: 70,
        multiplyer: 50,
        timer: 10,
        type: "potion",
      },
    ],
  },
  {
    title: "Speed potions",
    type: "item",
    color: "#1a68c8",
    miniimg: "potion-images/120px/speed1x1.webp",
    sizes: ["S", "M", "L"],
    stars: [1, 2, 3],
    variants: [
      // Small Speed Potion Variants (Power 1, 2, 3, Size S)
      {
        power: 1,
        size: "S",
        title: "Small Speed Potion",
        miniimg: "potion-images/120px/speed1x1.webp",
        cost: 1000,
        ddCost: 1,
        speedBonus: 1500,
        multiplyer: 10,
        timer: 1,
        type: "potion",
      },
      {
        power: 2,
        size: "S",
        title: "Small Speed Potion II",
        miniimg: "potion-images/120px/speed1x2.webp",
        ddCost: 5,
        speedBonus: 2500,
        multiplyer: 25,
        timer: 1,
        type: "potion",
      },
      {
        power: 3,
        size: "S",
        title: "Small Speed Potion III",
        miniimg: "potion-images/120px/speed1x3.webp",
        ddCost: 10,
        speedBonus: 3500,
        multiplyer: 50,
        timer: 1,
        type: "potion",
      },

      // Medium Speed Potion Variants (Power 1, 2, 3, Size M)
      {
        power: 1,
        size: "M",
        title: "Medium Speed Potion",
        miniimg: "potion-images/120px/speed2x1.webp",
        cost: 4000,
        ddCost: 4,
        speedBonus: 1500,
        multiplyer: 10,
        timer: 5,
        type: "potion",
      },
      {
        power: 2,
        size: "M",
        title: "Medium Speed Potion II",
        miniimg: "potion-images/120px/speed2x2.webp",
        ddCost: 17,
        speedBonus: 2500,
        multiplyer: 25,
        timer: 5,
        type: "potion",
      },
      {
        power: 3,
        size: "M",
        title: "Medium Speed Potion III",
        miniimg: "potion-images/120px/speed2x3.webp",
        ddCost: 40,
        speedBonus: 3500,
        multiplyer: 50,
        timer: 5,
        type: "potion",
      },

      // Large Speed Potion Variants (Power 1, 2, 3, Size L)
      {
        power: 1,
        size: "L",
        title: "Large Speed Potion",
        miniimg: "potion-images/120px/speed3x1.webp",
        cost: 7000,
        ddCost: 7,
        speedBonus: 1500,
        multiplyer: 10,
        timer: 10,
        type: "potion",
      },
      {
        power: 2,
        size: "L",
        title: "Large Speed Potion II",
        miniimg: "potion-images/120px/speed3x2.webp",
        ddCost: 35,
        speedBonus: 2500,
        multiplyer: 25,
        timer: 10,
        type: "potion",
      },
      {
        power: 3,
        size: "L",
        title: "Large Speed Potion III",
        miniimg: "potion-images/120px/speed3x3.webp",
        ddCost: 70,
        speedBonus: 3500,
        multiplyer: 50,
        timer: 10,
        type: "potion",
      },
    ],
  },
  {
    title: "Upgrade items",
    type: "item",
    color: "#df851b",
    miniimg: "upgrade-images/120px/scroll-3.webp",
    items: ["Upgrade luck", "Upgrade protect", "Upgrade scroll +1-3"],
    variants: [
      // Small Lucky Potion Variants (Power 1, 2, 3, Size S, M, L)
      {
        title: "Upgrade luck",
        miniimg: "upgrade-images/120px/luck-upgrade.webp",
        ddCost: 10,
        type: "upgrade-luck",
      },
      {
        title: "Upgrade protect",
        miniimg: "upgrade-images/120px/protect-upgrade.webp",
        ddCost: 10,
        type: "upgrade-protect",
      },
      {
        title: "Upgrade scroll +1-3",
        miniimg: "upgrade-images/120px/scroll-3.webp",
        ddCost: 3,
        type: "upgrade-scroll",
      },
    ],
  },
  {
    title: "AUTO$PIN BOT",
    type: "autospin",
    description: "Adds a button for automatic $PIN",
    color: "#4b8aed",
    miniimg: "donate-images/donate-bot.webp",
    ddCost: 280,
  },
];
export default shopItems;
